export default "__VITE_ASSET__CGEA6Vwq__"